import { NgModule }                from '@angular/core';
import { CommonModule }            from '@angular/common';
import { CsChatModule }            from '@cs/components/chat';
import { AiAnalystComponent }      from './page/ai-analyst.component';
import { AiAnalystRoutingModule }  from './page/ai-analyst-routing.module';

/**
 * Lazy-loaded full-page "AI Data Analyst". Routed at `/ai-analyst` (see the app's shell route
 * loader). Shares the {@link PmChatService}/{@link AgentContextService} singletons with the global
 * bubble, so both surfaces stream through the same transport and carry the same page context.
 */
@NgModule({
	declarations: [AiAnalystComponent],
	imports:      [CommonModule, CsChatModule, AiAnalystRoutingModule]
})
export class AiAnalystModule {
}
